import { FournisseurModel } from './../../../shared/models/societe-linked/fournisseur.model';
import { ModalRechercheFournisseurComponent } from './../modals/modal-recherche-fournisseur/modal-recherche-fournisseur.component';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DocumentService } from './../../../shared/services/simple/document.service';
import { DocumentModel } from './../../../shared/models/simple-types/document.model';
import { ModalAddBcDocumentComponent } from '../modals/modal-add-bc-document/modal-add-bc-document.component';
import { ModalShowBcDocumentComponent } from '../modals/modal-show-bc-document/modal-show-bc-document.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { DetailBcinfos } from 'src/app/core/bc/bc-components.service';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalGooglePickerComponent } from '../modals/modal-google-picker/modal-google-picker.component';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { SessionService } from 'src/app/shared/services/session.service';
import { filter, first } from 'rxjs/operators';
import { BcLineService } from 'src/app/shared/services/bc/bc-line.service';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { LivraisonBcService } from 'src/app/shared/services/bc/livraison-bc.service';
import { LivraisonBcModel } from 'src/app/shared/models/societe-linked/bc/livraison-bc.model';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

@Component({
  selector: 'app-bc-form',
  templateUrl: './bc-form.component.html',
  styleUrls: ['./bc-form.component.scss']
})
export class BcFormComponent implements OnChanges {

  @Input() form: UntypedFormGroup;
  @Input() detailBcInfo: DetailBcinfos;
  @Input() amountHT: number;
  @Input() amountTVA: number;
  @Input() amountTTC: number;
  @Output() changeEmit = new EventEmitter<any>();
  @Output() uploadDocument = new EventEmitter<DocumentModel[]>();

  withoutDoc = false;
  @Output() withoutDocs = new EventEmitter<boolean>();
  change: any = null;
  codeSite: string;
  showDocuments: boolean;
  documents: DocumentModel[];
  idBc: number;
  libelleSite: string;
  minDate: string = this.getMinDateBc();
  maxDate: string = moment(new Date()).format('YYYY-MM-DD');
  minDateFinValide: string = moment(new Date()).format('YYYY-MM-DD');
  naCg: CgChargeModel;
  documentSubscriber: Subscription;
  dModify = false;

  linesBc: Array<BcLineModel>;
  sumHtLivre: number;
  sumNonLivre: number;
  sumLivreNonprovisionne: number;
  sumDeprovionne: number;
  sumEncours: number;
  sumProvis: number;

  definitionTypeBC = DefinitionTypeBC; //utilisé dans l’html

  /* Prevent Saturday and Sunday for select. */
  weekendsDatesFilter = (d: Date): boolean => {
    if (d) {
      const day = d.getDay();
      return day !== 0 && day !== 6;
    }
  }

  constructor(
    public dialog: MatDialog,
    private documentService: DocumentService,

    private bcLineService: BcLineService,
    private livraisonBcService: LivraisonBcService,
    private sessionService: SessionService,
    public router: Router) {
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.form && changes.form.currentValue){
      this.dModify = changes.form.currentValue.get('fLivre').value !== NTHFlag.None ? true : false;
    }

    if (this.form) {
      this.form.get('dBc').valueChanges.subscribe(x => {
        this.minDateFinValide = this.getMinDateFinValide();
      });
      this.linesBc = this.form.controls["bcLines"].getRawValue();
      if(this.form.get('statusNum').value >= 10){
        this.sumHtLivre = this.calculateSumHtLivre();
        this.sumNonLivre = this.calculateSumNonLivre();
        this.sumLivreNonprovisionne = this.calculateSumLivreNonProvisionne();
        this.sumDeprovionne = this.calculateSumDeprovionne();
      }
      this.calculateSumEncours(this.sumDeprovionne);
    }
    if (this.form && this.form.get('id').value && !this.documentSubscriber) {
      this.idBc = this.form.get('id').value;

      this.documentSubscriber = this.documentService.getAllFromBc(this.idBc).subscribe(docs => {
        this.documents = docs;
        this.uploadDocument.emit(this.documents);
      });

      this.showDocuments = true;
    }
  }

  onChange(): void{
    this.withoutDoc = !this.withoutDoc;
    this.withoutDocs.emit(this.withoutDoc);
  }

  getMinDateBc(): string {
    const d = moment(new Date());
    if (d.day() === 2 || d.day() === 1) {
      return d.add(-4, 'days').format('YYYY-MM-DD');
    } else {
      return d.add(-2, 'days').format('YYYY-MM-DD');
    }
  }

  getMinDateFinValide(): string {
    if (this.form.get('dBc')) {
      if (this.form.get('dBc').value > Date.now) {
        return this.form.get('dBc').value;
      }
    }
    return moment(new Date()).format('YYYY-MM-DD');
  }

  showBcDocuments(): void {
    this.dialog.open(ModalShowBcDocumentComponent, {
      data: {
        idBc: this.form.get('id').value,
        documents: this.documents
      }
    }).afterClosed().subscribe(res => {
      this.documentService.getAllFromBc(this.idBc).subscribe(docs => {
        this.documents = docs;
        this.uploadDocument.emit(this.documents);
      });
    });
  }

  showAddDocument(): void {
    this.dialog.open(ModalAddBcDocumentComponent, {
      data: {
        idBc: this.form.get('id').value,
        documents: this.documents
      }
    }).afterClosed().subscribe(res => {
      this.documentService.getAllFromBc(this.idBc).subscribe(docs => {
        this.documents = docs;
        this.uploadDocument.emit(this.documents);
      });
    });
  }


  showAddDriveDocument(): void {
    this.sessionService.addScope('https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.readonly');
    this.sessionService.userResponseSubject.pipe(filter(user => {
      return this.sessionService.containsAskedScope();
    }), first()).subscribe((user) => {
      this.dialog.open(ModalGooglePickerComponent, {
        data: {
          id: this.form.get('id').value,
          type: 'BC'
        }
      }).afterClosed().subscribe(res => {
        this.documentService.getAllFromBc(this.idBc).subscribe(docs => {
          this.documents = docs;
          this.uploadDocument.emit(this.documents);
        });
      });
    });
  }

  openModalFournisseur(): void {
    this.dialog.open(ModalRechercheFournisseurComponent, {
      disableClose: true,
      data: {
        idSociete: this.form.get('idSociete').value,
      }
    }).afterClosed().subscribe((res: FournisseurModel) => {
      if (res) {
        this.form.get('codeFourn').setValue(res.code);
        this.form.get('libelleFourn').setValue(res.libelle);
      }
    });
  }

  calculateSumHtLivre(): number {
    var start = 0;
    if (this.form.get('type').value === DefinitionTypeBC.BCEnveloppe)
      start++;
    let sumHtLivre = 0;
    for (let i = start; i < this.linesBc.length; i++) {
      const htLivre = this.linesBc[i].qteLivre * this.linesBc[i].pu;
      sumHtLivre += htLivre;
    }
    return sumHtLivre;
  }

  calculateSumNonLivre(): number {
    var start = 0;
    if (this.form.get('type').value === DefinitionTypeBC.BCEnveloppe)
      start++;
    let sumNonLivre = 0;
    for (let i = start; i < this.linesBc.length; i++) {
      let NonLivre = 0;
      if(this.linesBc[i].qteRestant === 0){
        NonLivre  = 0;
      }else if (this.linesBc[i].qte > this.linesBc[i].qteLivre) {
        NonLivre  = (this.linesBc[i].qte - this.linesBc[i].qteLivre) * this.linesBc[i].pu;
      }
      sumNonLivre += NonLivre;
    }
    return sumNonLivre;
  }

  calculateSumLivreNonProvisionne(): number {
    var start = 0;
    if (this.form.get('type').value === DefinitionTypeBC.BCEnveloppe)
      start++;
    let sumLivreNonprovisionne = 0;
    for (let i = start; i < this.linesBc.length; i++) {
      if (this.linesBc[i].fProvis === NTHFlag.None) {
        const htLivre = this.linesBc[i].qteLivre * this.linesBc[i].pu;
        sumLivreNonprovisionne += htLivre;
      }
    }
    return sumLivreNonprovisionne;
  }

  calculateSumDeprovionne(): number {
    var start = 0;
    if (this.form.get('type').value === DefinitionTypeBC.BCEnveloppe)
      start++;
    let sumDeprovionne = 0;
    for (let i = start; i < this.linesBc.length; i++) {
      const deprovisionne = this.linesBc[i].qteDprovis * this.linesBc[i].pu;
      sumDeprovionne += deprovisionne;
    }
    return sumDeprovionne;
  }


  calculateSumEncours(sumDeprovionne: number): void {
    var start = 0;
    if (this.form.get('type').value === DefinitionTypeBC.BCEnveloppe)
      start++;
    let sumProvis = 0;
      for (let i = start; i < this.linesBc.length; i++) {
        for (let j = 0; j < this.linesBc[i].livraisonsBc.length; j++) {
          if (this.linesBc[i].livraisonsBc[j].bProvis === true) {
            sumProvis += this.linesBc[i].livraisonsBc[j].qteLivre * this.linesBc[i].pu;
          }
        }
      }
      this.sumEncours = sumProvis - sumDeprovionne;
  }
}
